




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxRequiredRule,
} from 'devextreme-vue/form';
import { ArticleTypeEnum } from '../enums/ArticleTypeEnum';
import { ArticlesClient, CreateArticleCommand, MeasuringUnitsClient, MeasuringUnit } from '@/data/web-api-client';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
  },
})
export default class ArticleCreatePopup extends Vue {
    private showPopup: boolean = false;
    private saving: boolean = false;

    private dto: IArticleCreateCommand = {
        name: '',
        type: 0,
        measuringUnit: '',
    };

    public show() {
      this.showPopup = true;
    }

    public hide() {
      this.showPopup = false;
    }

    public async save() {
        try {
          this.saving = true;
          const form: any = this.$refs.form;
          const validationResult = form.instance.validate();

          if (validationResult.isValid) {
            const command = new CreateArticleCommand({
              name: this.dto.name,
              type: this.dto.type,
              measuringUnit: this.dto.measuringUnit
            });
            const result = await new ArticlesClient(undefined, this.$axios).create(command);

            this.$store.commit('articles/addItem', result);
            notificationService.saved();
            this.$router.push({ path: `/articles/${result.id}` });
          } else {
            notificationService.invalidForm();
          }
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
          this.saving = false;
        }
    }

  get measuringunitOptions() {
    const measuringUnits = this.$store.getters['measuringUnits/data'];

    return { items: measuringUnits };
  }

  get articleTypesOptions() {
    const items = [
      {value: ArticleTypeEnum.Default, text: 'Basis'},
      {value: ArticleTypeEnum.Combiniation, text: 'Combinatie'},
    ];

    return { items, displayExpr: 'text', valueExpr: 'value' };
  }
}
